<template lang="html">
  <div class="overlayt" @click="preventClose">
    <div class="popupt" @click="preventClose">

          <h3  class="title">{{singlpk[0].pro_name}}</h3>

      <div class="pakovanje">
        <!-- <div class="slika">
          <img :src="proprourl+singlpk[0].pro_id"  alt=""  >
        </div> -->
        <!-- <p>Cena se obračunava po srednjem kursu NBS</p>
        <p v-if="kurs">Datum: {{kurs.date}} &nbsp <strong style="color:var(--crvena)">Kurs: 1 € = {{kurs.value}} rsd</strong> </p>
        <br> -->
        <table>
          <tr>
            <th v-if='pak[0].pro_duzni == 1'>Odaberite pakovanje:</th>
            <th v-if='pak[0].pro_duzni > 1'>Odaberite debljinu folije:</th>
            <td>
              <select class="" v-model="selected" >
                 <option v-if="pak" v-for="(pa,index) in pak" :value="index">{{ pa.pak_naziv }}</option>
                 <option value=""  selected="selected" disabled="disabled" style="display: none">Odaberite pakovanje</option>
             </select>
            </td>
          </tr>
          <tr>
            <th v-if='pak[0].pro_duzni == 1'>Cena pakovanja:</th>
            <th v-if='pak[0].pro_duzni > 1'>Cena po m2:</th>
            <td> {{(this.pak[selected].pro_cena * kurs ).toFixed(2) }} rsd </td>

          </tr>
          <tr v-if='pak[0].pro_duzni > 1'>
            <th >Cena po m':</th>
            <td> {{(this.pak[selected].pro_cena * kurs *this.pak[selected].pro_duzni ).toFixed(2) }} rsd </td>
          </tr>
          <tr>
            <th v-if='pak[0].pro_duzni == 1'>Odaberite količinu:</th>
            <th v-if='pak[0].pro_duzni > 1'>Odaberite dužinu:</th>
            <td><input type="number" min="0" max="20"  value="" v-model="kol"> </td>
          </tr>
          <tr>
            <th >UKUPNO:</th>
            <td>{{(ukupno * kurs).toFixed(2)}} rsd   </td>
          </tr>

        </table>
       <!-- <span> <strong>Ukupno:</strong> {{dinara}} rsd  / {{ ukupno}} €</span> -->
       <!-- <br> -->
      </div>
      <br>

    <div class="alert">
     {{err}}
    </div>
     <div class="zadnji">
         <input type="button" name="" value="Dodaj u korpu" @click="dodaj()"><i class="fas fa-cart-arrow-down"></i>
     </div>

      <div class="">
        <button @click="close()"> X</button>

      </div>

    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
export default {
  data(){
    return{
      dinara:'',
      selected:0,
      ukupno:0,
      kol:0,
      err:"",
      cena:0

    }
  },
  watch:{
    selected:function(){
      if(this.selected !==""){
        this.kol = 0
        this.cena = this.pak[this.selected].pro_cena
          this.ukupno = (this.pak[this.selected].pro_cena * this.kol * this.pak[this.selected].pro_duzni).toFixed(2)

        // this.dinara = (this.ukupno * this.kurs.value).toFixed(2)
        // this.err=''
      }

    },
    kol:function(){
      if(this.selected  !==""){
        this.ukupno = (this.pak[this.selected].pro_cena * this.kol * this.pak[this.selected].pro_duzni).toFixed(2)
        // this.dinara = (this.ukupno * this.kurs.value).toFixed(2)
      }

    },
  },
  created(){

    if (this.pak) {
      this.cena = this.pak[0].pro_cena * this.pak[0].pro_duzni
      this.ukupno = 0.00
    }

  },
  computed:{
    ...mapGetters([
      'singlpk',
      'pak',
      'pojedinacna',
      'podkaturl',
      'proprourl',
      'brandurl',
      'cart',
      'kurs',
      'pakname'
    ]),

  },
methods:{
  close(){
    this.err=''
    this.selected=0
    this.kol=0
    this.cena=0
    this.ukupno = 0
    this.setpojedinacna(false)
  },
  ...mapActions([
      'getsinglpk',



  ]),
  ...mapMutations([
    'setterms',
    'setpojedinacna',
    'setcart',
    'changecart',
    'settotal'

  ]),
  preventClose (e) {
      			e.stopPropagation()
      		},
    dodaj(){
        if(this.kol <1){
          return this.err = 'Odaberite kolicinu'
        }
        this.err=''
        var objekat = {}
        objekat.kolicina = this.kol;
        objekat.ime = this.singlpk[0].pro_name
        objekat.pro_id = this.singlpk[0].pro_id
        objekat.pakovanje = this.pak[this.selected].pak_naziv
        objekat.cena = (this.pak[this.selected].pro_cena * this.pak[this.selected].pro_duzni ).toFixed(2)
        this.selected=0
        this.kol=0
        this.ukupno = 0
        var isto = false
        if(this.cart.length > 0){
          for (var i = 0; i < this.cart.length; i++) {
            if(this.cart[i].pro_id == objekat.pro_id && this.cart[i].pakovanje == objekat.pakovanje){
              isto = true
            }
          }
        }

        if(!isto){
          this.err = 'Proizvod je ubačen u korpu'
          this.setcart(objekat)

        }
        if(isto) {
          this.changecart(objekat)
          this.err = 'Količina je promenjena'
        }

        this.settotal(this.cart)
        // this.err = 'Proizvod je ubačen u korpu'

    },

    selectOnly(name) {
        var cb=document.querySelectorAll('input[class="cena"]')
        cb.forEach((i)=>{
          i.checked=false
        })
      document.getElementById(name).checked = true;
      },
},


  mounted(){

    // this.getkurs()
    // this.getsinglpk('1')
    // console.log(this.selected);
    // console.log(this.singlpk);
  }
}
</script>

<style lang="css">
table tr:nth-child(odd){
  background: var(--siva)
}

</style>



// WEBPACK FOOTER //
// src/components/pojedinacna.vue